const translationString = (id: string, intl: any) => {
  const { formatMessage } = intl;
  return formatMessage({ id });
}

export default translationString;
